import { render, staticRenderFns } from "./ListaAreaEmbargadaPiaui.vue?vue&type=template&id=1f2efad4&lang=pug"
import script from "./ListaAreaEmbargadaPiaui.vue?vue&type=script&lang=js"
export * from "./ListaAreaEmbargadaPiaui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports